import { render, staticRenderFns } from "./PdfElement.vue?vue&type=template&id=6ff31f7b&scoped=true&"
import script from "./PdfElement.vue?vue&type=script&lang=ts&"
export * from "./PdfElement.vue?vue&type=script&lang=ts&"
import style0 from "./PdfElement.vue?vue&type=style&index=0&id=6ff31f7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff31f7b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSnackbar,VTooltip})
